/**
 * Created by rhillion on 01/07/2017.
 */
import React from 'react';
import {
    BrowserRouter as Router,
    Route,
    Redirect
} from 'react-router-dom'

import {firebaseAuth} from './helpers/fire';
import Login from './Login';
import Register from './Register';
import Landing from './Landing';
import PrivacyPolicy from './PrivacyPolicy';
import App from './App';

const PrivateRoute = ({component: Component, authed, ...rest}) => (
    <Route {...rest} render={props => (
        authed === true
            ? <Component {...props}/>
            : <Redirect to={{
                pathname: '/login', state: {from: props.location}
            }}/>
    )}/>
)

class Routes extends React.Component {

    state = {
        authed: false,
        loading: true,
    }

    componentDidMount() {
        this.removeListener = firebaseAuth().onAuthStateChanged((user) => {
            console.log('logged in zzz!', user)
            if (user) {
                this.setState({
                    authed: true,
                    loading: false,
                })
            } else {
                this.setState({
                    authed: false,
                    loading: false
                })
            }
        })
    }

    componentWillUnmount() {
        this.removeListener()
    }

    render() {
        return this.state.loading === true ? <h1>Loading</h1> : (
                <Router {...this.props}>
                    <div>
                        <Route exact path="/" component={Landing}/>
                        <Route path="/login" component={Login}/>
                        <Route path="/register" component={Register}/>
                        <Route path="/privacypolicy" component={PrivacyPolicy}/>
                        <PrivateRoute authed={this.state.authed} path="/cards" component={App}/>
                        <PrivateRoute authed={this.state.authed} path="/places" component={App}/>
                    </div>
                </Router>
            )
    }
}

export default Routes;


// WEBPACK FOOTER //
// ./src/routes.js